export const prevent = event => event?.preventDefault();
export const stop = event => event?.stopPropagation();

export const handleWith = (...handlers) => {
	const fnHandlers = handlers.filter(handler => typeof handler === "function");
	return event => fnHandlers.forEach(handler => handler(event));
};
